import styles from "./AscAdminInfo.module.scss";
import classNames from "classnames";

export interface AscAdminInfoProps {
  className?: string;
  color?: string;
  icon?: any;
  title?: string | number;
  subTitle?: string;
}

export default function AscAdminInfo({
  className,
  color,
  icon,
  title,
  subTitle,
}: AscAdminInfoProps) {
  return (
    <div className={classNames(styles.ground, className)}>
      <div
        className={classNames(styles.iconGround)}
        style={{ background: `${color}` }}
      >
        <div className={styles.icon}>{icon}</div>
      </div>
      <h3 className={styles.title}>{title}</h3>
      <p className={styles.subTitle}>{subTitle}</p>
    </div>
  );
}
